export enum SchedulingTypeEnum {
  PickupTime = 'scheduledPickupTime',
  ArrivalTime = 'scheduledArrivalTime',
  HotStandbyTime = 'hotStandbyTime',
}
